import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import {TranslateModule} from '@ngx-translate/core';
import {brand} from '../../../settings';
import {TralalereBarModule} from '../tralalere-bar/tralalere-bar.module';
import {ButtonHelpModule} from "fuse-core/components/button-help/button-help.module";
import {FreemiumRewardProgressBarComponent} from './freemium-reward-progress-bar/freemium-reward-progress-bar.component';

@NgModule({
    declarations: [
        ToolbarComponent
    ],
    imports: [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        MatTooltipModule,
        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule,
        TranslateModule,
        TralalereBarModule,
        ButtonHelpModule,
        FreemiumRewardProgressBarComponent
    ],
    exports     : [
        ToolbarComponent
    ]
})
export class ToolbarModule
{
    public brand: string = brand;
}